import API from './API'
const route = 'dispatch-area/'
import Record_behavir from './FirebaseAPI/RecordBill'
import Cookies from 'js-cookie'

var record = new Record_behavir()

var Dispatch_area = (function () {
  function dispatch_area() {}
  dispatch_area.prototype.getDetail = function (id) {
    return API.get(`${route}?id=${id}`)
  }
  dispatch_area.prototype.getArea = function () {
    return API.get(`${route}area`)
  }
  dispatch_area.prototype.create = async (data) => {
    return await API.post(`dispatch-area`, data)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '派遣區域'
        recordInfo.event = '新增派遣區'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = res.id
        recordInfo.note = {
          name: data.name,
          dispatchStrategy: data.dispatch_strategy,
        }
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  dispatch_area.prototype.delete = async function (id) {
    return await API.delete(`${route}delete/?id=${id}`)
      .then((res) => {
        if (!res.success) throw new RangeError(res.result)
        let recordInfo = {}
        recordInfo.type = '派遣區域'
        recordInfo.event = '移除派遣區'
        recordInfo.code = Cookies.get('GladTeamCode')
        recordInfo.id = id
        recordInfo.note = ''
        recordInfo.user_name = Cookies.get('GladName')
        recordInfo.user_id = ''
        record.postRecord(recordInfo)
        return {
          success: true,
          message: res.result,
        }
      })
      .catch((err) => {
        return {
          success: false,
          message: err,
        }
      })
  }
  dispatch_area.prototype.update = async function (id, task, data) {
    return await API.put(`${route}update/?id=${id}&task=${task}`, data)
      .then((res) => {
        // 檢查 API 回傳的 success 欄位
        if (res.success === false) {
          throw new RangeError(res.result || res.message || '更新失敗')
        }
        // 如果 success 為 true，視為成功
        // 記錄行為日誌（不影響主要流程，即使失敗也不影響更新結果）
        try {
          let recordInfo = {}
          recordInfo.type = '派遣區域'
          recordInfo.event = '更新派遣區'
          recordInfo.code = Cookies.get('GladTeamCode')
          recordInfo.id = id
          recordInfo.note = ''
          recordInfo.user_name = Cookies.get('GladName')
          recordInfo.user_id = ''
          // 確保 postRecord 的錯誤不會影響主要流程
          record.postRecord(recordInfo).catch((err) => {
            console.warn('記錄行為日誌失敗，但不影響更新結果:', err)
          })
        } catch (err) {
          // 同步錯誤也不影響主要流程
          console.warn('記錄行為日誌時發生錯誤，但不影響更新結果:', err)
        }
        // 無論記錄是否成功，都返回成功結果
        return {
          success: true,
          message: res.result || res.message || '更新成功',
        }
      })
      .catch((err) => {
        // 只有在 API 明確失敗時才返回失敗
        if (err instanceof RangeError) {
          return {
            success: false,
            message: err.message,
          }
        }
        // 其他錯誤（如網路錯誤）也返回失敗
        return {
          success: false,
          message: err,
        }
      })
  }
  return dispatch_area
})()
export default Dispatch_area



// WEBPACK FOOTER //
// ./src/assets/js/libs/Dispatch_area.js